import { SubmitButton } from "components/common/buttons/SubmitButton";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { fetchInterpreters } from "slices/interpreterSlice";
import { selectCustomStyles } from "../common/Select";
import { AsyncPaginate } from "react-select-async-paginate";
import ErrorMessage from "components/common/ErrorMessage";
import { fetchVendorInterpreters } from "slices/vendor/interpreterSlice";
import { fetchAvailableVendorInterpreters } from "slices/vendor/interpreterSlice";

function SelectInterpreterModal({
  isOpen,
  onClose,
  onConfirm,
  item,
  loader,
  appointmentId,
}) {
  const dispatch = useDispatch();
  const methods = useForm();
  const {
    setFocus,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    setError: setErrors,
    clearErrors,
  } = methods;

  useEffect(() => {
    // Build interpreter object if available
    let interpreterObj = null;
    if (item?.vendor_interpreter?.first_name && item?.vendor_interpreter?.id) {
      const fullName = [item?.vendor_interpreter?.first_name, item?.vendor_interpreter?.last_name].filter(Boolean).join(' ');
      interpreterObj = {
        label: fullName,
        value: item?.vendor_interpreter?.id || "",
      };
    }
    setFilterInterpreters(interpreterObj);
    setValue("interpreter_id", interpreterObj ? interpreterObj.value : "");
    setValue("reference_no", item?.reference_no || "");
    clearErrors("interpreter_id");
    methods.reset({ interpreter_id: interpreterObj ? interpreterObj.value : "", reference_no: item?.reference_no || "" });
    if (interpreterObj) {
      methods.trigger("interpreter_id");
    }
  }, [item, isOpen]);

  // #region Interpreter Dropdown
  const [filterInterpreters, setFilterInterpreters] = useState({
    label: "",
    value: "",
  });

  // Remove this effect, logic now handled in the above effect

  const filteredInterpretersLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchAvailableVendorInterpreters(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: (result?.data || []).map((val) => ({
        value: val.id,
        label: [val.first_name, val.last_name].filter(Boolean).join(' '),
      })),
      hasMore: result?.last_page ? page < result.last_page : false,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
        <FormProvider {...methods}>
          <form
            action=""
            onSubmit={handleSubmit((data) => onConfirm(data, "assign"))}
          >
            <ModalHeader className="header_modal align-items-center">
              <h5 className="modal-title_u">
                {item?.interpreter_id ? "Reassign" : "Assign"}
              </h5>
            </ModalHeader>
            <ModalBody className="modal_form_body">
              <div className="step_cards step_1">
                <h2>{item?.interpreter_id ? "Reassign" : "Assign"}</h2>
                {/* INTERPRETER SELECT */}
                <div className="row-primary">
                  <h2>Interpreter *</h2>
                  <div className="w-100">
                    <Controller
                      name="interpreter_id"
                      rules={{
                        required: "Please select interpreter",
                      }}
                      control={control}
                      render={({ field }) => (
                        <div style={{ width: "100%" }}>
                          <AsyncPaginate
                            menuPlacement="auto"
                            styles={{
                              ...selectCustomStyles,
                            }}
                            value={filterInterpreters}
                            loadOptions={filteredInterpretersLoadOptions}
                            isClearable
                            escapeClearsValue
                            onChange={(obj) => {
                              if (obj?.value) {
                                setFilterInterpreters(obj);
                                field.onChange(obj.value);
                                clearErrors("interpreter_id");
                              } else {
                                setFilterInterpreters(null);
                                field.onChange("");
                              }
                            }}
                            additional={{
                              page: item?.state?.id ? 2 : 1,
                            }}
                          />
                        </div>
                      )}
                    />
                    {errors?.interpreter_id?.message && (
                      <ErrorMessage text={errors.interpreter_id.message} />
                    )}
                  </div>
                </div>
                <div className="row-primary mt-3">
                  <h2>Reference No</h2>
                  <div className="w-100">
                    <Controller
                      name="reference_no"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="text"
                          className="input-in type_inp"
                          placeholder="Enter reference number"
                          {...field}
                        />
                      )}
                    />
                    {errors?.reference_no?.message && (
                      <ErrorMessage text={errors.reference_no.message} />
                    )}
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <SubmitButton btnText="Submit" loader={loader} />
              <button className="table_delete" type="button" onClick={onClose}>
                Cancel
              </button>
            </ModalFooter>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
}

export default SelectInterpreterModal;
